export const sideMenuItems = [
    {
        id: 'dashboard',
        label: 'Dashboard',
        description: 'Dashboard',
        path: '/dashboard/summary',
        disabled: false,
        hidden: false,
        menuType: 'link',
        icon: 'bi-clipboard-data-fill',
    },
    {
        id: 'sellers',
        label: 'Sellers',
        description: 'View all Sellers',
        path: '/sellers',
        disabled: false,
        hidden: true,
        menuType: 'link',
        icon: 'bi-people-fill',
        showFor: 'superadmin',
    },
    {
        id: 'servicenearSellers',
        label: 'Companies',
        description: 'View all servicenear using companies',
        path: '/servicenear/superadmin',
        disabled: false,
        hidden: true,
        menuType: 'link',
        icon: 'bi-buildings-fill',
        showFor: 'servicenearSuperadmin',
    },
    {
        id: 'sales',
        label: 'Sales',
        description: 'View Orders & Returns',
        disabled: false,
        hidden: false,
        menuType: 'expandable',
        expanded: false,
        icon: 'bi-cash-stack',
        children: [
            {
                id: 'allOrders',
                label: 'All orders',
                description: 'View all Orders',
                path: '/sales/all-orders',
                disabled: false,
                hidden: false,
                menuType: 'link',
                icon: 'bi-box-fill',
            },
            {
                id: 'allReturns',
                label: 'All returns',
                description: 'View all Returns',
                path: '/sales/all-returns',
                disabled: false,
                hidden: false,
                menuType: 'link',
                icon: 'bi-box2-fill',
            },
            {
                id: 'pos',
                label: 'POS',
                description: 'Create sales using POS',
                path: '/sales/pos',
                disabled: true,
                hidden: false,
                menuType: 'link',
                icon: 'bi-arrow-right-circle-fill',
            },
        ],
    },
    {
        id: 'products',
        label: 'Products',
        description: 'Products Overview & Management',
        disabled: false,
        hidden: false,
        menuType: 'expandable',
        expanded: false,
        icon: 'bi-boxes',
        children: [
            {
                id: 'addProduct',
                label: 'Add product',
                description: 'Add new products',
                path: '/products/product-edit/0',
                disabled: false,
                hidden: false,
                menuType: 'link',
                icon: 'bi-plus-circle-fill',
            },
            {
                id: 'productList',
                label: 'Products',
                description: 'View all products',
                path: '/products/product-list',
                disabled: false,
                hidden: false,
                menuType: 'link',
                icon: 'bi-boxes',
            },
            {
                id: 'highlightedProducts',
                label: 'Highlighted Products',
                description: 'Manage highlighted products',
                path: '/products/Highlighted',
                disabled: false,
                hidden: false,
                menuType: 'link',
                icon: 'bi-basket-fill',
            },
            {
                id: 'categories',
                label: 'Categories',
                description: 'View and add categories',
                path: '/products/categories',
                disabled: false,
                hidden: false,
                menuType: 'link',
                icon: 'bi-basket2',
            },
            {
                id: 'damageList',
                label: 'Damage List',
                description: 'View all Damagelist',
                path: '/products/Damagelist',
                disabled: false,
                hidden: false,
                menuType: 'link',
                icon: 'bi-basket3-fill',
            },
            {
                id: 'reviewList',
                label: 'Review List',
                description: 'View All Customer Reviews',
                path: '/products/ReviewList',
                disabled: false,
                hidden: false,
                menuType: 'link',
                icon: 'bi-star-half',
            },
        ],
    },
    {
        id: 'secondhand',
        label: 'Secondhand',
        description: 'View and manage secondhand orders',
        disabled: false,
        hidden: false,
        menuType: 'expandable',
        expanded: false,
        icon: 'bi-phone',
        children: [
            {
                id: 'createSecondhandPurchase',
                label: 'Create Secondhand Purchase',
                description: 'Create secondhand purchase',
                path: '/secondhand/purchaseAdd',
                disabled: false,
                hidden: false,
                menuType: 'link',
                icon: 'bi-plus-circle-fill',
            },
            {
                id: 'secondhandList',
                label: 'Secondhand List',
                description: 'View all Secondhand Purchases',
                path: '/secondhand/purchaseList',
                disabled: false,
                hidden: false,
                menuType: 'link',
                icon: 'bi-list-ul',
            },
        ]
    },
    {
        id: 'users',
        label: 'Users',
        description: 'View all users',
        path: '/user/list',
        disabled: false,
        hidden: false,
        menuType: 'link',
        icon: 'bi-person-badge-fill',
    },
    {
        id: 'customers',
        label: 'Customers',
        description: 'Customer Overview & Management',
        disabled: false,
        hidden: false,
        menuType: 'expandable',
        expanded: false,
        icon: 'bi-people-fill',
        children: [
            {
                id: 'customerList',
                label: 'Customers',
                description: 'View all customers',
                path: '/user/userlist',
                disabled: false,
                hidden: false,
                menuType: 'link',
                icon: 'bi-people-fill',
            },
            {
                id: 'activeCart',
                label: 'Active Cart',
                description: 'View all customers Cart',
                path: '/cart/Active-cart',
                disabled: false,
                hidden: false,
                menuType: 'link',
                icon: 'bi-cart-check-fill',
            },
            {
                id: 'addCustomer',
                label: 'Add Customer',
                description: 'Create new customer',
                path: '/user/customer-add/user',
                disabled: false,
                hidden: false,
                menuType: 'link',
                icon: 'bi-plus-circle-fill',
            },
            {
                id: 'abandonedCart',
                label: 'Abandoned Cart',
                description: 'View all customers Abandoned Cart',
                path: '/cart/Abandoned-cart',
                disabled: false,
                hidden: false,
                menuType: 'link',
                icon: 'bi-cart-dash-fill',
            },
            {
                id: 'wishlist',
                label: 'Wishlist',
                description: 'View all customers Wishlist',
                path: '/admin/wishlist',
                disabled: false,
                hidden: false,
                menuType: 'link',
                icon: 'bi-bag-heart-fill',
            },
            // {
            //     id: 'refrralcodes',
            //     label: 'Referral Codes',
            //     description: 'View all Referral Codes',
            //     path: '/admin/referral',
            //     disabled: false,
            //     hidden: false,
            //     menuType: 'link',
            //     icon: 'bi-bag-heart-fill',
            // },
        ],
    },
    {
        id: 'loyalty',
        label: 'Loyalty',
        description: 'Loyalty Points Overview & Management',
        disabled: false,
        hidden: false,
        menuType: 'expandable',
        expanded: false,
        icon: 'bi-star-fill',
        children: [
            {
                id: 'transactions',
                label: 'Transactions',
                description: 'View Loyalty Transactions',
                path: '/loyalty/transactions',
                disabled: false,
                hidden: false,
                menuType: 'link',
                icon: 'bi-bookmark-star-fill',
            },
            {
                id: 'customerwiseTransactions',
                label: 'Customerwise Transactions',
                description: 'View Customerwise Transactions',
                path: '/loyalty/customerwise',
                disabled: false,
                hidden: false,
                menuType: 'link',
                icon: 'bi-bookmark-star-fill',
            },
            
        ],
    },
    {
        id: 'vendor',
        label: 'Vendor',
        description: 'Vendor Overview & Management',
        disabled: false,
        hidden: false,
        menuType: 'expandable',
        expanded: false,
        icon: 'bi-briefcase-fill',
        children: [
            {
                id: 'createVendor',
                label: 'Create Vendor',
                description: 'Create New Vendor',
                path: '/vendor/add',
                disabled: false,
                hidden: false,
                menuType: 'link',
                icon: 'bi-plus-circle-fill',
            },
            {
                id: 'vendorList',
                label: 'Vendor List',
                description: 'View Vendors List',
                path: '/vendor/list',
                disabled: false,
                hidden: false,
                menuType: 'link',
                icon: 'bi-list-ul',
            },
            
        ],
    },
    {
        id: 'purchases',
        label: 'Purchases',
        description: 'Purchases Overview & Management',
        disabled: false,
        hidden: false,
        menuType: 'expandable',
        expanded: false,
        icon: 'bi-basket3-fill',
        children: [
            {
                id: 'createPurchase',
                label: 'Create Purchase',
                description: 'Create New Purchase',
                path: '/purchases/add',
                disabled: false,
                hidden: false,
                menuType: 'link',
                icon: 'bi-plus-circle-fill',
            },
            {
                id: 'purchaseList',
                label: 'Purchase List',
                description: 'View Vendors List',
                path: '/purchases/list',
                disabled: false,
                hidden: false,
                menuType: 'link',
                icon: 'bi-list-ul',
            },
            
        ],
    },
    {
        id: 'reports',
        label: 'Reports',
        description: 'View Reports',
        disabled: true,
        hidden: false,
        menuType: 'expandable',
        expanded: false,
        icon: 'bi-list-columns',
        children: [
            {
                id: 'salesReport',
                label: 'Sales Report',
                description: 'View sales report',
                path: '/reports/sales',
                disabled: true,
                hidden: false,
                menuType: 'link',
                icon: 'bi-list-check',
            },
            {
                id: 'profitReport',
                label: 'Profit Report',
                description: 'View profit report',
                path: '/reports/profit',
                disabled: true,
                hidden: false,
                menuType: 'link',
                icon: 'bi-list-check',
            },
            {
                id: 'salesProfitReport',
                label: 'Sales Profit Report',
                description: 'View sales profit report',
                path: '/reports/sales-profit',
                disabled: true,
                hidden: false,
                menuType: 'link',
                icon: 'bi-list-check',
            },
            {
                id: 'dayWiseReport',
                label: 'Day Wise Report',
                description: 'View day wise profit report',
                path: '/reports/day-wise',
                disabled: true,
                hidden: false,
                menuType: 'link',
                icon: 'bi-list-check',
            },
            {
                id: 'productWiseReport',
                label: 'Product Wise Report',
                description: 'View product wise profit report',
                path: '/reports/product-wise',
                disabled: true,
                hidden: false,
                menuType: 'link',
                icon: 'bi-list-check',
            },

            {
                id: 'deadStockReport',
                label: 'Dead Stock Report',
                description: 'View dead stock report',
                path: '/reports/dead-stock',
                disabled: true,
                hidden: false,
                menuType: 'link',
                icon: 'bi-list-check',
            },
            {
                id: 'damageReport',
                label: 'Damage Report',
                description: 'View damage report',
                path: '/reports/damage',
                disabled: true,
                hidden: false,
                menuType: 'link',
                icon: 'bi-list-check',
            },
        ],
    },
    {
        id: 'banners',
        label: 'Banners',
        description: 'View & manage top banners',
        path: '/admin/top-banners',
        disabled: false,
        hidden: true,
        menuType: 'link',
        icon: 'bi-stickies-fill',
    },
    {
        id: 'settings',
        label: 'Settings',
        description: 'Setting Overview & Management',
        disabled: false,
        hidden: false,
        menuType: 'expandable',
        expanded: false,
        icon: 'bi-gear-fill',
        children: [
            {
                id: 'settingsMain',
                label: 'General Settings',
                description: 'Configure your setting here',
                path: '/profile/Settings',
                disabled: false,
                hidden: false,
                menuType: 'link',
                icon: 'bi-wrench-adjustable',
            },
            
        ],
    },
    {
        id: 'store',
        label: 'Store',
        description: 'Store Overview & Management',
        disabled: false,
        hidden: false,
        menuType: 'expandable',
        expanded: false,
        icon: 'bi-house-gear',
        children: [
            {
                id: 'storeSettings',
                label: 'Settings',
                description: 'Configure your store Setting here',
                path: '/profile/Store-settings',
                disabled: false,
                hidden: false,
                menuType: 'link',
                icon: 'bi-gear-fill',
            },
        ]
    },
    {
        id: 'website',
        label: 'Website',
        description: 'Website Overview & Management',
        disabled: false,
        hidden: false,
        menuType: 'expandable',
        expanded: false,
        icon: 'bi-globe',
        children: [
            {
                id: 'websiteSettings',
                label: 'Settings',
                description: 'Configure your website here',
                path: '/profile/WebsiteContent',
                disabled: false,
                hidden: false,
                menuType: 'link',
                icon: 'bi-gear-fill',
            },
            {
                id: 'seoSettings',
                label: 'SEO',
                description: 'Configure SEO data here',
                path: '/profile/SEOSettings',
                disabled: false,
                hidden: false,
                menuType: 'link',
                icon: 'bi-gear-wide',
            },
        ]
    },
    {
        id: 'dvCard',
        label: 'DV Card',
        description: 'DV Card Overview & Management',
        disabled: false,
        hidden: false,
        menuType: 'expandable',
        expanded: false,
        icon: 'bi-person-vcard-fill',
        children: [
            {
                id: 'dvcardContent',
                label: 'Settings',
                description: 'Configure Dvcard Content',
                path: '/profile/dvcard',
                disabled: false,
                hidden: false,
                menuType: 'link',
                icon: 'bi-gear-fill',
            },
        ]
    },
    {
        id: 'menuCard',
        label: 'Menu Card',
        description: 'Menu Card Overview & Management',
        disabled: false,
        hidden: false,
        menuType: 'expandable',
        expanded: false,
        icon: 'bi-menu-up',
        children: [
            {
                id: 'menuCardSettings',
                label: 'Settings',
                description: 'Configure Menu Card Settings',
                path: '/profile/menucard',
                disabled: false,
                hidden: false,
                menuType: 'link',
                icon: 'bi-gear-fill',
            },
        ]
    },
    {
        id: 'whatsnew',
        label: "What's New",
        description: 'See updates in Version_',
        path: '/admin/whatsnew',
        disabled: false,
        hidden: false,
        menuType: 'link',
        icon: 'bi-award-fill',
    },
];

export const profileMenuItems = [
    {
        id: 'profile',
        label: 'Profile',
        description: 'View & manage profile details',
        path: '/profile/profile',
        disabled: false,
        hidden: false,
        menuType: 'link',
        icon: 'bi-person-circle',
    },
    {
        id: 'subscription',
        label: 'Subscription',
        description: 'View current plan & limits',
        path: '/profile/SubscriptionDetails',
        disabled: false,
        hidden: false,
        menuType: 'link',
        icon: 'bi-table',
    },
    {
        id: 'logout',
        label: 'Logout',
        description: 'Signout your current account',
        path: '/logout',
        disabled: false,
        hidden: false,
        menuType: 'link',
        icon: 'bi-box-arrow-right',
    },
]